import { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CheckoutLayout,
  LoadingLayout,
  Loading
} from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { getClubSignup } from 'redux/clubSignup/actions';
import { useLocalization } from 'redux/localization/utils/hooks';
import useIsClubSignupProductRoute from 'utils/hooks/useIsClubSignupProductRoute';

const LoadableComponent = lazy(() => retry(() => import('./App')));

const AppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  const clubSignupReducer = useSelector((state) => state.clubSignup);

  const isProductRoute = useIsClubSignupProductRoute();

  useEffect(() => {
    if (isProductRoute) {
      dispatch(getClubSignup(false));
    } else {
      dispatch(getClubSignup(true));
    }
  }, [dispatch, isProductRoute]);

  if (!clubSignupReducer.data) {
    return <LoadingLayout />;
  }

  return (
    <CheckoutLayout title={t('clubSignup.signup.clubSignup')}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </CheckoutLayout>
  );
};

export default AppLoader;
